import { render, staticRenderFns } from "./RecepcionValidacionFacturas.vue?vue&type=template&id=38d69b66&scoped=true"
import script from "./RecepcionValidacionFacturas.vue?vue&type=script&lang=js"
export * from "./RecepcionValidacionFacturas.vue?vue&type=script&lang=js"
import style0 from "./RecepcionValidacionFacturas.vue?vue&type=style&index=0&id=38d69b66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d69b66",
  null
  
)

export default component.exports